module.exports = __webpack_public_path__ + "static/img/brees-2016-top-image-thumb.182da43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-top-image-thumb.jpg
// module id = 5iVm
// module chunks = 1